import Rect from "./Rect"
import BaseContainer from './BaseContainer';
import {UIEvent} from '../const/Event';
export default class ScrollerBar extends BaseContainer{
    constructor(thumb){
        super();

        this.bg = this._getDefaultBg();
        this.addChild(this.bg);

        this._thumb = thumb || this._getDefaultThumb();
        this.addChild(this._thumb);

        this._posKey = null;
        this._sizeKey = null;
        this._isHorizon = true;
        this.isHorizon = true;
        this.isThumbDragging = false;
        this.isMouseDown = false;
        this.thumbLastPos = 0;

        this.thumbSizePercent = 1;
        this.autoThumbSize = true;
        this.maxOffset = 0;
        this.autoThumbSize = true;

        this.interactive = true;
        this.on('mousedown', (e) => this.onMouseDown(e));
        this.on('mouseup', (e) => this.onMouseUp(e));
        this.on('mousemove', (e) => this.onMouseMove(e));
        this.on('mouseupoutside', (e) => this.onMouseUp(e));
        this.on('mouseout', this.onMouseOut, this);
        this.on('mouseover', this.onMouseOver, this);
    }

    get percent(){
        return  this.maxOffset ? this._thumb[this._posKey] / this.maxOffset : 1;
    }
    set percent(value){
        //拖拽的时候，不接受外部控制
        if(this.isThumbDragging){ return; }
        value = Math.max(0, Math.min(1, value));
        this._thumb[this._posKey] = this.maxOffset * value;
    }

    get thumb(){
        return this._thumb;
    }

    setThumbPos(p){
        const max = this[this._sizeKey] - this._thumb[this._sizeKey];
        p = Math.max(0, Math.min(max, Math.floor(p)));
        this._thumb[this._posKey] = p;
        this.emit(UIEvent.PERCENT_CHANGED, this.percent);
    }

    setPercentParams(totalSize, visibleSize, scrollValue){
        this.setScrollerSize(totalSize, visibleSize);
        const max = totalSize - visibleSize;
        if(max > 0){
            this.percent = scrollValue / max;
        } else {
            this.percent = 1;
        }
    }

    setScrollerSize(totalSize, visibleSize){
        const percent = visibleSize / totalSize;
        this.thumbSizePercent = percent;
        this.resize(this.width, this.height);
    }

    resize(w, h){
        const oldPercent = this.percent;
        this.width = w;
        this.height = h;

        if(this.autoThumbSize){
            this._thumb[this._sizeKey] = Math.min(Math.max(this[this._sizeKey] * this.thumbSizePercent, 50), this.width);
        }
        this.bg.width = this.width;
        this.bg.height = this.height;
        this.updateMaxOffset();
        this.percent = oldPercent;
    }

    get isHorizon(){
        return this._isHorizon;
    }
    set isHorizon(value){
        this._isHorizon = value;
        this._posKey = value ? "x" : "y";
        this._sizeKey = value ? "width" : "height";
        this.updateMaxOffset();
    }

    updateMaxOffset(){
        this.maxOffset = this[this._sizeKey] - this._thumb[this._sizeKey];
    }

    onMouseDown(e) {
        const p = e.data.getLocalPosition(this);
        const thumbMin = this._thumb[this._posKey];
        const thumbMax = thumbMin + this._thumb[this._sizeKey];
        const pos = p[this._posKey];
        if(pos >= thumbMin && pos < thumbMax){
            this.isThumbDragging = true;
            this.thumbLastPos = pos;
        } else {
            this.isThumbDragging = false;
            this.setThumbPos(pos - this._thumb[this._sizeKey] / 2);
        }
        this.isMouseDown = true;
        this._stopPropagation(e);
    }

    onMouseUp(e) {
        if(this.isThumbDragging) {
            this.isThumbDragging = false;
        }
        this.isMouseDown = false;
    }

    onMouseMove(e) {
        if(this.isThumbDragging) {
            const p = e.data.getLocalPosition(this);
            const diff = 10;
            if(isNaN(p.x) || p.x < -diff || p.y < -diff || p.x > this.width + diff || p.y > this.height + diff)
            {
                return;
            }
            const pos = p[this._posKey];
            const dPos = pos - this.thumbLastPos;
            this.thumbLastPos = pos;
            this.setThumbPos(this._thumb[this._posKey] + dPos);
            this._stopPropagation(e);
        }
    }

    onMouseOut(e) {
        this.isThumbDragging = false;
    }

    onMouseOver(e) {
        if(this.isMouseDown){
            this.isThumbDragging = true;
            this.onMouseMove(e);
        }
    }

    _stopPropagation(e){
        let data = e.data;
        data = data && data.originalEvent;
        if(data){
            data.stopImmediatePropagation();
            data.stopPropagation();
            data.preventDefault();
        }
    }

    redraw(){
        if(this._thumb){
            this._thumb.redraw();
        }
    }

    _getDefaultThumb(){
        return new Rect({fillColor:0xc1c1c1, cornerRadius: 5});
    }

    _getDefaultBg(){
        return new Rect({fillColor:0x272727, cornerRadius: 0});
    }
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/component/ScrollerBar.js